import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { ENV_NAME } from '../../constants/environment'

import {
    setRecoveryCart,
    updateAllFees,
    resetSpokesman
} from '../../store/actions/cart'
import {
    closeAllModal,
    closeModalCnpj,
    setOldCompany,
    openModalLead,
    setCnpjLead
} from '../../store/actions/lead'
import { setName } from '../../store/actions/bank'

import { bankNameSelector } from '../../store/selectors/bank'
import { cartSelector } from '../../store/selectors/cart'

import ImagePreloader from '../../components/ImagePreloader'
import MainBanners from '../../components/MainBanners'
import ProjectInfoBanner from './components/ProjectInfoBanner'
import InfosContainer from './components/InfosContainer'
import StampsContainer from './components/StampsContainer'
import FaqContainer from './components/FaqContainer'
import ProductsList from '../../components/ProductsList'
import ModalLoading from './components/ModalLoading'
import ModalReatriveError from './components/ModalReatriveError'
import ModalMaintenanceProduct from '../Proposal/components/ModalMaintenanceProduct'

import { recovery } from '../../api/cart'
import * as companyType from '../../constants/company-types'
import ScrollUp from '../../utils/ScrollUp'

import './Home.scss'
import StringFormat from '../../utils/StringFormat'
import { TagPushHome } from '../../analytics/home'

const Home = (props) => {
    const [reatriveLoading, setReatriveLoading] = useState(false)
    const [reatriveError, setReatriveError] = useState(false)
    const [maintenaceProduct, setMaintenaceProduct] = useState(false)

    const requestRecovery = (cartId, token) => {
        recovery(cartId, { verificationCode: token })
            .then((response) => {
                const data = response.data
                const status = response.status

                if (status === 204) {
                    setReatriveLoading(false)
                    setMaintenaceProduct(true)
                    return
                }

                props.setRecoveryCart(data)
                switch (data.code) {
                    case companyType.NEW:
                        props.closeAllModal()
                        props.getTaxa()
                        break
                    case companyType.PME:
                    case companyType.CORP:
                        props.setCnpjLead(data.company.document)
                        props.resetSpokesman()
                        props.openLogin()
                        break
                    default:
                }

                setReatriveLoading(false)
                props.history.push('/proposta')
            })
            .catch(() => {
                setReatriveError(true)
                setReatriveLoading(false)
            })
    }

    useEffect(() => {
        const { cartId, token, bank = '' } = props.match.params

        TagPushHome.screenView(bank)

        if (cartId && token) {
            setReatriveLoading(true)
            requestRecovery(cartId, token)
        }

        if (bank) {
            props.setBankName(bank)
        }
    }, [])

    return (
        <div className="home">
            <ScrollUp />

            <ImagePreloader
                images={[
                    `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/shopback/refeicao.png`,
                    `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/shopback/alimentacao.png`,
                    `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/shopback/cultura.png`,
                    `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/shopback/natal.png`,
                    `https://www.alelo.com.br/content/dam/ecommerce/${ENV_NAME}/shopback/generico.png`
                ]}
            />

            <MainBanners carousel={true} bank={props.bankName} />
            {reatriveLoading && <ModalLoading open={reatriveLoading} />}
            {reatriveError && (
                <ModalReatriveError
                    open={reatriveError}
                    onClick={() => {
                        setReatriveError(false)
                        props.history.push('/')
                    }}
                />
            )}
            {maintenaceProduct && (
                <ModalMaintenanceProduct
                    open={maintenaceProduct}
                    onClick={() => {
                        setMaintenaceProduct(false)
                        props.history.push('/')
                    }}
                />
            )}
            <ProductsList
                main
                onRetry={() =>
                    props.getProducts(
                        StringFormat.bankAbbreviation(props.bankName)
                    )
                }
            />
            {!props.bankName && <ProjectInfoBanner bankName={props.bankName} />}
            <StampsContainer />
            {!props.bankName && <InfosContainer bankName={props.bankName} />}
            <FaqContainer bank={props.bankName} />
        </div>
    )
}

const mapStateToProps = (state) => ({
    cart: cartSelector(state),
    bankName: bankNameSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    setBankName: (name) => dispatch(setName(name)),
    setRecoveryCart: (data) => dispatch(setRecoveryCart(data)),
    closeAllModal: () => dispatch(closeAllModal()),
    getTaxa: () => dispatch(updateAllFees()),
    setCnpjLead: (value) => dispatch(setCnpjLead(value)),
    openLogin: () => {
        dispatch(closeModalCnpj())
        dispatch(openModalLead())
        dispatch(setOldCompany())
    },
    resetSpokesman: () => dispatch(resetSpokesman())
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
